export default __webpack_public_path__ + "static/media/GR00018-talents_card_2.6276db70.svg";